import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { clx } from "../../../utils/Helpers";
import "./UIRowActionsMenu.scss";

const UIRowActionsMenu = ({
  ariaLabel,
  className,
  disabled,
  items,
  triggerDisabled,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const lang = useSelector((state) => state.locale.lang);
  const open = Boolean(anchorEl);
  const visibleItems = (items || []).filter(Boolean);

  const close = () => setAnchorEl(null);

  if (!visibleItems.length) {
    return null;
  }

  const isTriggerDisabled =
    triggerDisabled ?? (disabled || visibleItems.every((item) => item.disabled));

  return (
    <div
      className={clx("ui-row-actions-menu", className)}
      onClick={(event) => event.stopPropagation()}
    >
      <IconButton
        aria-label={ariaLabel || "actions"}
        className="ui-row-actions-menu__trigger"
        color="inherit"
        disabled={isTriggerDisabled}
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon className="ui-row-actions-menu__trigger-icon" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: lang === "en" ? "right" : "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: lang === "en" ? "right" : "left",
        }}
        MenuListProps={{
          className: "ui-row-actions-menu__list",
        }}
        PaperProps={{
          className: "ui-row-actions-menu__paper",
          elevation: 0,
        }}
      >
        {visibleItems.map((item) => (
          <MenuItem
            key={item.key}
            className={clx(
              "ui-row-actions-menu__item",
              "text-body-sm",
              item.success && "ui-row-actions-menu__item--success",
              item.danger && "ui-row-actions-menu__item--danger",
            )}
            disabled={item.disabled}
            disableRipple
            onClick={() => {
              close();
              item.onClick?.();
            }}
          >
            <span className="ui-row-actions-menu__item-label">{item.label}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

UIRowActionsMenu.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      success: PropTypes.bool,
      danger: PropTypes.bool,
    }),
  ).isRequired,
  triggerDisabled: PropTypes.bool,
};

UIRowActionsMenu.defaultProps = {
  ariaLabel: "",
  className: "",
  disabled: false,
  triggerDisabled: undefined,
};

export default UIRowActionsMenu;
